$(function () {
  if ($("#benefits") && window.location.hash.substring(1) === "benefits") {
    window.scrollTo({
      top: $("#benefits").offset().top - 100,
      behavior: "smooth",
    });
  }

  const $languageSections = {
    en: $(".en-privacyMembers"),
    cn: $(".cn-privacyMembers"),
    jp: $(".jp-privacyMembers"),
  };

  function showLanguageSection(lang) {

    $.each($languageSections, function (key, $section) {
      $section.addClass("d-none");
    }); // Show selected language section
    if ($languageSections[lang]) {
      $languageSections[lang].removeClass("d-none");
    } // Update select value to reflect the language
    $('.display__lang--label').text(lang.toUpperCase());
    $select.val(lang);
    $select
      .find('option[value="' + lang + '"]')
      .text(lang.toUpperCase())
      .addClass("selected");
  }
  var $select = $(".language-selector select");
  $('.language-selector').addClass("d-none");
  const currentHash = window.location.hash.replace("#", "");
  const supportedLangs = ["en", "cn", "jp"];
  const defaultLang = "jp";

  if (supportedLangs.includes(currentHash)) {
    $(".language-selector").removeClass("d-none");
    showLanguageSection(currentHash);
  } else {
    $(".language-selector").removeClass("d-none");
    showLanguageSection(defaultLang);
  }

  $select.on("change", function () {
    var selectedCode = $(this).val();
    $(this)
      .find("option")
      .each(function () {
        $(this).text('');
        if ($(this).val() === selectedCode) {
          $('.display__lang--label').text(selectedCode.toUpperCase());
          showLanguageSection(selectedCode);
          window.location.hash = selectedCode;
        }
      });
  });

  $select.on("mousedown", function () {
    $(this)
      .find("option")
      .each(function () {
        $(this).text($(this).data("text"));
    });
  });

  $select.on("focusout", function () {
    $('.display__lang--label').text($select.val().toUpperCase());
    $(this)
      .find("option")
      .each(function () {
        $(this).text('');
    });
  });

});
